import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class BlockNews {
	constructor() {

		let blocks = document.querySelectorAll('.block-news');

		blocks.forEach((block) => {
			const swiper = block.querySelector('.swiper');
			const prev = block.querySelector(".navigation-button-prev");
			const next = block.querySelector(".navigation-button-next");
			const pagination = block.querySelector('.swiper-custom-pagination');
			const slider = new Swiper(swiper, {
				slidesPerView: "auto",
				spaceBetween: 20,
				breakpoints: {
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2
					},
					992: {
						slidesPerView: 3,
						slidesPerGroup: 3
					}
				},
				grabCursor: true,
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
				pagination: {
					el: pagination,
					type: 'bullets',
					bulletElement: 'span',
					clickable: true
				}
			});

			slider.slides.forEach( (slide) => {
				gsap.set(slide,{
					opacity: 0,
					xPercent: 10
				});
			});

			ScrollTrigger.create({
				trigger: swiper,
				start: 'top 75%',
				onEnter: () => {
					gsap.to(slider.slides,{
						opacity: 1,
						xPercent: 0,
						stagger: 0.2
					});
				}
			});

		});

	}
}
